import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { withTracking } from '../../../observability';
import { StackingCardsSection } from './StackingCardsSection';

export default createBuilderModule(
  withChildren(
    withTracking(StackingCardsSection, { sectionName: 'StackingCardsSection' }),
  ),
  {
    name: 'StackingCardsSection',
    inputs: [
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'cards',
        type: 'list',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'heading',
            type: 'string',
          },
          {
            name: 'details',
            type: 'richText',
          },
          {
            name: 'image',
            type: 'object',
            subFields: [
              {
                name: 'url',
                type: 'cloudinaryMediaLibrary',
              },
              {
                name: 'alt',
                type: 'string',
              },
            ],
          },
        ],
      },
    ],
  },
);
